export default __webpack_public_path__ + "static/B0157-1817475904000e6d1f1dd3928d00034e.png";